import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { GridOptions } from "ag-grid-community";
import ng from "angular";
import { ImsPolandMarketDataProvider } from "../../Market/services/imsPolandMarketDataProvider";
import "./imsBrandFilterComponent.less";

class ImsBrandFilterComponentController {
    public filterConfig: $TSFixMe;
    public gridApi: $TSFixMe;
    public imsBrandFilterGridOptions: GridOptions;
    public availableMolecules: $TSFixMe[];
    public availableAtc3: $TSFixMe[];
    public availableAtc4: $TSFixMe[];
    public availableNfc3: $TSFixMe[];
    public pharmacyMarkets: $TSFixMe[];
    public perscirptionMarkets: $TSFixMe[];
    public moleculeTypes: $TSFixMe[];
    public onFilterAdding: $TSFixMe;

    static $inject = [
        "$scope",
        ImsPolandMarketDataProvider.componentName,
        AgGridService.componentName,
        angularServicesNames.$translate
    ];

    constructor(
        private $scope: ng.IScope,
        private imsPolandMarketDataProvider: ImsPolandMarketDataProvider,
        private agGridService: AgGridService,
        private $translate: ng.translate.ITranslateService
    ) {
        this.availableMolecules = [];
        this.availableAtc3 = [];
        this.availableAtc4 = [];
        this.availableNfc3 = [];
        this.pharmacyMarkets = [];
        this.perscirptionMarkets = [];
        this.moleculeTypes = [];
    }

    $onInit() {
        this.filterConfig = {};
        this.resetFilter();

        this.loadPharmacyMarkets();
        this.loadPerscirptionMarket();
        this.loadMoleculeType();

        this.$scope.$on("LanguageChanged", () => this.agGridService.refreshGridLanguage(this.gridApi));

        this.initializeGridOptions();
    }

    private initializeGridOptions() {
        this.imsBrandFilterGridOptions = {
            columnDefs: [
                {
                    headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.BRAND"),
                    field: "brand",
                    cellRenderer: "agGroupCellRenderer"
                },
                {
                    headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.COMPANY"),
                    field: "company"
                },
                {
                    headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.MARKET"),
                    field: "market"
                },
                {
                    headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.MOLECULES"),
                    field: "molecules",
                    sortable: false,
                    cellRenderer: () =>
                        '<div class="ui-grid-cell-contents" title="{{ data.molecules | join: \',\' }}"><span ng-repeat-start="m in data.molecules">{{m}}<span ng-if="!$last">, </span></span><span ng-repeat-end=""></span></div>'
                }
            ],
            angularCompileRows: true,
            animateRows: true,
            masterDetail: true,
            defaultColDef: {
                sortable: true,
                resizable: true
            },
            suppressHorizontalScroll: false,
            detailCellRendererParams: {
                detailGridOptions: {
                    columnDefs: [
                        { field: "sku" },
                        {
                            field: "pharmacyMarket",
                            headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.PHARMACY_MARKET")
                        },
                        {
                            field: "atcOtc3",
                            headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.ATCOTC3")
                        },
                        {
                            field: "atcOtc4",
                            headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.ATCOTC4")
                        },
                        {
                            field: "nfc3",
                            headerValueGetter: () => this.$translate.instant("MARKET.SELECTED_SKU_GRID.NFC3")
                        }
                    ],
                    domLayout: "autoHeight",
                    angularCompileRows: true,
                    localeTextFunc: this.agGridService.transalteFunc,
                    onFirstDataRendered(params: $TSFixMe) {
                        // fit the detail grid columns
                        params.api.sizeColumnsToFit();
                    }
                },
                getDetailRowData: (params: $TSFixMe) => {
                    for (const sku of params.data.skus) {
                        sku.parentBrand = params.data;
                    }
                    params.successCallback(params.data.skus);
                }
            },
            getRowHeight: (params: $TSFixMe) => {
                if (params.node && params.node.detail) {
                    const offset = 80;
                    const allDetailRowHeight = params.data.skus.length * 28;
                    return allDetailRowHeight + offset;
                } else {
                    // otherwise return fixed master row height
                    return 30;
                }
            },
            pagination: true,
            paginationPageSize: 10,
            rowModelType: "serverSide",
            rowGroupPanelShow: "never",
            suppressMultiSort: true,
            domLayout: "autoHeight",
            localeTextFunc: this.agGridService.transalteFunc,
            onGridReady: config => {
                this.gridApi = config.api;
                config.api.setServerSideDatasource(this.imsPolandMarketDataProvider.createBrandsDataSource(this.filterConfig));
                config.api.sizeColumnsToFit();
            },
            onGridSizeChanged: config => {
                config.api.sizeColumnsToFit();
            }
        };
    }

    public brandNameFilterChange() {
        if (this.filterConfig.brand.length > 2 || this.filterConfig.brand.length == 0) {
            this.reloadBrands();
        }
    }

    public skuNameChanged() {
        if (this.filterConfig.sku.length > 2 || this.filterConfig.sku.length == 0) {
            this.reloadBrands();
        }
    }

    public findMolecule(searchString: string) {
        this.imsPolandMarketDataProvider.findMolecule(searchString).then((data: $TSFixMe) => {
            this.availableMolecules = data;
        });
    }

    public findAtc3(searchString: string) {
        this.imsPolandMarketDataProvider.findAtc3(searchString).then((data: $TSFixMe) => {
            this.availableAtc3 = data;
        });
    }

    public findNfc3(searchString: string) {
        this.availableNfc3 = [];
        const molecules = this.filterConfig.molecules.map((x: $TSFixMe) => x.name);

        const debounce = _.debounce(
            (searchString: string, molecules: string[]) =>
                this.imsPolandMarketDataProvider.findNfc3(searchString, molecules).then((data: $TSFixMe) => {
                    this.availableNfc3 = data;
                }),
            500
        );

        debounce(searchString, molecules);
    }

    public loadPharmacyMarkets() {
        this.imsPolandMarketDataProvider.loadPharmacyMarkets().then((data: $TSFixMe) => {
            this.pharmacyMarkets = data;
        });
    }

    public loadPerscirptionMarket() {
        this.imsPolandMarketDataProvider.loadPerscirptionMarket().then((data: $TSFixMe) => {
            this.perscirptionMarkets = data;
        });
    }

    public loadMoleculeType() {
        this.imsPolandMarketDataProvider.loadMoleculeType().then((data: $TSFixMe) => {
            this.moleculeTypes = data;
        });
    }

    private resetFilter() {
        this.filterConfig.pharmacyMarket = null;
        this.filterConfig.perscirptionMarket = null;
        this.filterConfig.atc3 = null;
        this.filterConfig.atc4 = null;
        this.filterConfig.nfc3 = [];
        this.filterConfig.molecules = [];
        this.filterConfig.brand = null;
        this.filterConfig.moleculeType = null;
        this.filterConfig.type = "include";
        this.filterConfig.sku = null;
        this.filterConfig.onlySelectedMolecues = false;
    }

    public reloadBrands() {
        if (this.gridApi) {
            this.gridApi.onFilterChanged();
        }
    }

    public addFitler() {
        const filterConfig = angular.copy(this.filterConfig);

        filterConfig.nfc3 = _.map(filterConfig.nfc3, (f: $TSFixMe) => f.fullName);
        filterConfig.molecules = _.map(filterConfig.molecules, (f: $TSFixMe) => f.name);

        this.onFilterAdding({ filter: filterConfig });
        this.resetFilter();
    }

    // Setup watcher for atc3 change
    $postLink() {
        this.$scope.$watch(
            () => this.filterConfig.atc3,
            (newValue: $TSFixMe) => {
                if (newValue) {
                    this.imsPolandMarketDataProvider.loadAtc4(this.filterConfig.atc3).then((data: $TSFixMe) => {
                        this.availableAtc4 = data;
                    });
                } else {
                    this.availableAtc4 = [];
                    this.filterConfig.atc4 = null;
                }
            }
        );
    }
}

export class ImsBrandFilterComponent implements ng.IComponentOptions {
    static componentName = "imsBrandFilter";
    bindings = {
        onFilterAdding: "&"
    };
    controller = ImsBrandFilterComponentController;
    template = require("./imsBrandFilterComponent.html");
}

angular.module("topline.modules").component(ImsBrandFilterComponent.componentName, new ImsBrandFilterComponent());
